// Components
import { Button } from '@tracklib/kit'
import NewsletterSubscribe from 'components/base/newsletter/newslettersubscribe'

// Hooks
import { useSubscription } from 'modules/subscription/hooks'
import { useIsAuthenticated } from 'modules/auth/hooks'
import { useSignupCode } from 'modules/signup/hooks'

import styles from 'components/base/newsletter/newslettersubscribe.css'

const StartFreeTrial = () => {
  const { reftitle, reftext, refcode } = useSignupCode()

  return (
    <section className={styles.wrapper}>
      <p className={styles.title}>{reftitle}</p>
      <p className={styles.description}>{reftext}</p>
      <Button variant="white" to={`/subscribe/${refcode !== 'default' ? refcode : ''}`}>
        Subscribe
      </Button>
    </section>
  )
}

const TrialAndNewsletterCta = (): JSX.Element => {
  const isAuthenticated = useIsAuthenticated()
  const subscription = useSubscription()
  const hasFreeTier = subscription?.state === 'FREE'

  if (!isAuthenticated || hasFreeTier) {
    return <StartFreeTrial />
  }
  return <NewsletterSubscribe />
}

export default TrialAndNewsletterCta
